export const base_url = "/app"